<!--

 -->

<template>
  <oxd-input-field
    type="select"
    :options="options"
    :label="$t('attendance.timezone')"
    :show-empty-selector="false"
  />
</template>

<script>
import {ref, onBeforeMount} from 'vue';
import {APIService} from '@ohrm/core/util/services/api.service';
export default {
  name: 'TimezoneDropdown',
  setup() {
    const options = ref([]);
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/attendance/timezones',
    );

    onBeforeMount(() => {
      http.getAll().then(({data}) => {
        options.value = data.data.map((timezone) => {
          return {
            id: timezone.name,
            label: `(GMT${timezone.label}) ${timezone.name}`,
            _offset: parseFloat(timezone.offset),
          };
        });
      });
    });

    return {
      options,
    };
  },
};
</script>
